module.exports = "/_next/static/images/a31a2ef1de0cecb8aface04edd44b31b-card-md.png.webp";